@if (loading) {
    <app-loader class="ml-4" />
} @else {
    @for (data of metadata; track $index) {
        <div class="flex flex-column">
            <app-content-field
                class="metadata"
                [required]="data.isRequired"
                [label]="data.fieldLabel.toUpperCase()"
                [warning]="!data.isValid"
                [rowGap]="data.isValid">
                {{ data.fieldValue }}
            </app-content-field>
            @if (!data.isValid) {
                <span class="warning-text text-med text-xs color-orange5"
                    >The selected option has been removed from the RMS
                    settings. This will not affect discrepancy progress, but
                    consider updating the selection to maintain
                    compliance.</span
                >
            }
        </div>
    }
    @if (metadata.length > columnCount && metadata.length % columnCount > 0) {
        @for (cell of placeholderCells(); track $index) {
            <div class="metadata"></div>
        }
    }
    @if (metadata.length === 0) {
        <div class="ml-5">No metadata found.</div>
    }
}
